import React, { useState, useEffect } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap'
import DeleteModal from "components/Common/DeleteModal"
import AvField from "availity-reactstrap-validation/lib/AvField"
import AvForm from "availity-reactstrap-validation/lib/AvForm"
import { SuccessOk } from 'configs/statusCode'
import { toast } from 'react-toastify'
import { adminPrefix } from 'configs/routePrefix'
import { useSelector } from "react-redux"

const CardItem = (props) => {
    const { index, item, Service, updateHandler, status, setShouldGetData } = props
    const [deleteModal, setDeleteModal] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [itemStatus, setItemStatus] = useState(false)
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")

    useEffect(() => {
        setItemStatus(status)
    }, [status])
    const service = new Service
    const toggle = () => setDropdownOpen(prevState => !prevState)
    const handleCloseModal = (action, response) => {
        setDeleteModal(false)
        if (action === "delete") {
            setShouldGetData(true)
        }
    }

    const changeStatus = (e) => {
        const value = e.target.checked
        service.toggleStatus(item.id).then((res) => {
            if (res && res.status === SuccessOk) {
                toast.success("Status Changed Successfully")
                setItemStatus(value)
                toast.success(res.data.success)
                setTimeout(() => {
                    setShouldGetData(true)
                }, 1000)

            }
        })
    }
    return (
        <tr key={index} className="payment-bgBadge">
            <td className='font-size-14'>{item.id}</td>
            <th className='font-size-14  ' style={{ textDecoration: "underline", fontWeight: 700 }}>{item.name.en}</th>
            <th className='font-size-14'> {item.compounds ?.map((comp, index) => {
                return (
                    <Badge
                        key={index}
                        className="bgBadge font-size-14 mt-0 m-1"
                        style={{ background: "#50a5f1", marginTop: "0px !important" }}
                    >
                        {comp.name.en}
                    </Badge>
                )
            })}</th>
            <td className='font-size-14 py-0'>
                <form>
                    <div className='form-check form-switch form-switch-md mb-1'>
                        <input
                            name='status'
                            checked={itemStatus}
                            type='checkbox'
                            className='form-check-input'
                            id='has_status'
                            onChange={changeStatus}
                            disabled={isExist("payment.edit") ? false : true}

                        />
                    </div>
                </form>
            </td>
            {isExist("payment.edit") || isExist("payment.delete") ?<td className="removebtnhover">
                <Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                    <DropdownToggle caret>
                        <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                        {isExist("payment.edit") ?
                            <DropdownItem onClick={updateHandler}>Edit</DropdownItem>
                            : null}
                        {isExist("payment.delete") ? <DropdownItem className="text-danger" onClick={() => {
                            setDeleteModal(!deleteModal)
                        }}>Remove Payment Plan</DropdownItem> : null}
                    </DropdownMenu>
                </Dropdown>
            </td>:null}
            <DeleteModal
                open={deleteModal}
                titleMsg={name.en}
                deletedItem={item}
                modelService={service}
                onCloseModal={(action) => handleCloseModal(action)}
            />
        </tr>


    )
}

export default CardItem